<template>
    <div
        :class="{
            'card-project-wrapper': true,
            'card-project-wrapper--registration-is-closed': isShowClosedReg && !hideStatus,
            'card-project-wrapper--registration-is-open': isShowOpenReg && !hideStatus,
            'card-project-wrapper--active': expandedEntityId === project.id,
        }"
    >
        <div
            :class="{
                'card-project': true,
                'card-project--registration-is-open': isShowOpenReg && !hideStatus,
            }"
        >
            <div class="card-project__body" @click="goToProject">
                <div
                    class="card-project__status card-project__status--opened-registration"
                    v-if="!project.participantStatus && project.registration_is_open"
                >
                    <IconOpenedReg />
                    Открыта регистрация
                </div>
                <div v-if="!hideStatus">
                    <div class="card-project__status card-project__status--closed-registration" v-if="isShowClosedReg">
                        Сообщим о старте
                    </div>

                    <div
                        :class="{
                            'card-project__status': true,
                            [`card-project__status--${projectStatus.field_name}`]: true,
                        }"
                        v-if="project.participantStatus"
                    >
                        {{ projectStatus.field_value }}
                    </div>
                </div>

                <div class="card-project__favorite-btn">
                    <FavoriteToggle :entityId="project.id" entityType="projects" />
                </div>

                <h3 class="card-project__title" :title="project.title">{{ project.title }}</h3>

                <div class="card-project__footer">
                    <div class="card-project__image-wrapper">
                        <img v-if="project.preview" class="card-project__image" :src="project.preview" />
                    </div>
                    <div class="card-project__type" :style="{ backgroundColor: projectType.color }">
                        {{ projectType.text }}
                    </div>
                </div>
            </div>
            <TagsDropdown
                :entityId="project.id"
                :expandedEntityId="expandedEntityId"
                :foreignCompetenceIds="project.foreign_competence_ids"
                :foreignCourseAreasId="project.foreign_course_area_ids"
                :variant="isShowOpenReg && !hideStatus ? 'success' : 'default'"
                @onExpandedTags="$emit('onExpandedTags', project.id)"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import IconOpenedReg from '@/views/track/icons/IconOpenedReg.vue';
import FavoriteToggle from './components/FavoriteToggle.vue';

import TagsDropdown from './components/TagsDropdown.vue';

const ProjectTypeColors = {
    facetoface_event: 'rgba(246, 218, 215, 1)',
    project: 'rgba(207, 227, 245, 1)',
    contest: 'rgba(217, 215, 231, 1)',
};

export default {
    name: 'CardProject',
    components: {
        IconOpenedReg,
        FavoriteToggle,

        TagsDropdown,
    },
    props: {
        project: {
            type: Object,
            required: true,
        },
        expandedEntityId: {
            type: [String, Number],
            default: null,
        },
        hideStatus: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapGetters('data', ['getRegistryItems']),

        projectType() {
            const projectType = this.getRegistryItems('spk_project_type').find(
                (item) =>
                    item.id === this.project.project_type ||
                    (this.project.project && item.id === this.project.project.type)
            );
            return projectType
                ? {
                      color: ProjectTypeColors[projectType.field_name],
                      text: projectType.field_value,
                  }
                : {
                      color: 'rgba(212, 212, 212, 1)',
                      text: 'Публикация',
                  };
        },

        projectStatus() {
            const projectStatus = this.getRegistryItems('stage_history').find(
                (item) => item.id === this.project.participantStatus
            );

            return projectStatus ? projectStatus : '';
        },

        isShowStatus() {
            return !!this.project.participantStatus;
        },
        isShowOpenReg() {
            return this.project.registration_is_open && !this.project.participantStatus;
        },

        isShowClosedReg() {
            return !this.project.participantStatus && !this.project.registration_is_open;
        },
    },

    methods: {
        goToProject() {
            window.open(`https://${window.rsvDomain}/competitions/project/1/${this.project.id}/`, '_blank');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.card-project-wrapper {
    position: relative;
    width: 100%;
    height: urem(290);

    @include on-desktop {
        height: urem(290);
        width: urem(252);
    }

    &--active {
        z-index: 2;
    }

    &--registration-is-closed {
        .card-project {
            &__title {
                opacity: 0.6;
            }

            &__type {
                opacity: 0.6;
            }
        }

        :deep(.tag) {
            background-color: rgba(242, 244, 250, 1);
            color: rgba(191, 191, 191, 1);
        }
    }
}

.card-project {
    position: absolute;
    width: 100%;
    background-color: #fff;
    border-radius: urem(16);
    min-height: urem(290);
    display: flex;
    flex-direction: column;
    font-family: $font-montserrat;
    box-shadow: 0 0 urem(20) 0 rgba(70, 99, 171, 0.2);
    overflow: visible;
    z-index: 1;

    &--registration-is-open {
        box-shadow: 0 0 urem(10) 0 rgba(104, 200, 122, 0.8);
    }

    @include on-desktop {
        min-height: urem(290);
        width: urem(252);
    }

    &__body {
        padding-top: urem(30);
        flex: 1;
        cursor: pointer;
    }

    &__status {
        display: flex;
        align-items: center;
        gap: urem(6);
        font-size: urem(12);
        font-weight: 600;
        padding: urem(6) urem(8);
        position: absolute;
        top: 0;
        left: 0;
        border-top-left-radius: urem(16);
        border-bottom-right-radius: urem(16);
        height: urem(24);

        background: rgba(236, 239, 247, 1);
        color: rgba(70, 99, 171, 1);

        &--party {
            background: rgba(236, 239, 247, 1);
            color: rgba(70, 99, 171, 1);
        }

        &--half {
            background: rgba(231, 241, 250, 1);
            color: rgba(107, 159, 203, 1);
        }

        &--final {
            background: rgba(217, 215, 231, 1);
            color: rgba(105, 96, 159, 1);
        }

        &--candidate {
            background: rgba(246, 218, 215, 1);
            color: rgba(219, 108, 97, 1);
        }

        &--opened-registration {
            color: white;
            background: rgba(104, 200, 122, 1);

            :deep(svg) {
                width: urem(16);
                height: urem(16);
            }
        }

        &--closed-registration {
            color: white;
            background: rgba(155, 158, 166, 1);
        }
    }

    &__favorite-btn {
        position: absolute;
        top: urem(5);
        right: urem(5);
    }

    &__title {
        font-size: urem(14);
        font-weight: 600;
        color: rgba(37, 31, 69, 1);
        padding: urem(10) urem(16);
        line-height: urem(20);
        margin: 0;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        height: urem(70);
    }

    &__footer {
        display: flex;
        align-items: center;
        min-height: urem(70);
        padding-right: urem(16);
        justify-content: space-between;

        @include on-desktop {
            padding-right: 0;
        }
    }

    &__image-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: urem(120);
        height: urem(70);
        padding: urem(10);
        flex-shrink: 0;
        margin-left: urem(7);
    }

    &__image {
        display: block;
        width: urem(100);
        height: urem(50);
    }

    &__type {
        display: block;

        border-radius: urem(20);
        min-width: urem(95);
        color: rgba(19, 22, 20, 1);
        font-size: urem(10);
        font-weight: 500;
        text-align: center;
        line-height: urem(24);
        height: urem(24);
        background: rgba(212, 212, 212, 1);

        @include on-desktop {
            margin: 0 urem(16) 0 0;
        }
    }
}
</style>
